import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, typeface, typography, getResetByTag, utilityStyles, rem } from './../../../styles';
import StyledButtonGroupItemContainer from './button-group.item-container.styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("align-items:center;background-color:transparent;border:0;color:", colors.navy_500, ";display:flex;font-family:", typeface.typefaceBase, ";font-size:", rem(14), ";font-weight:", typography.typographyFontWeightNormal, ";height:", rem(34), ";line-height:", typography.typographyLineHeightXs, ";margin-right:", rem(5), ";min-width:", rem(73), ";outline:none;padding:", rem(5, 16), ";position:relative;text-align:center;&:last-child{margin-right:0;}&:first-of-type{", StyledButtonGroupItemContainer, "{&::before{display:none;}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var isInverseStyles = function isInverseStyles(_ref) {
  var isInverse = _ref.isInverse;
  if (isInverse) {
    return /*#__PURE__*/css(StyledButtonGroupItemContainer, "{&::before{background-color:", colors.navy_500, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:isInverseStyles;"));
  }
};
var resetStyles = getResetByTag('label');
var StyledButtonGroupItem = /*#__PURE__*/_styled('label', process.env.NODE_ENV === "production" ? {
  target: "e1x00utt0"
} : {
  target: "e1x00utt0",
  label: "StyledButtonGroupItem"
})(resetStyles, defaultStyles, utilityStyles, isInverseStyles);
export default StyledButtonGroupItem;